import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { cancelTask } from "./api";
import {
  handleTaskActionError,
  invalidateTaskViews,
} from "./invalidateTaskViews";

// Отмена задачи с UI. На успех инвалидируем кэши task,
// task-events, tasks и queue — статус, лог переходов, список и
// активная задача очереди могут все измениться (cancel освободил
// очередь → backend в фоне активирует следующую через
// dispatch_next_in_queue). Инвалидация по смысловому префиксу матчит
// запись любого org-скоупа (см. `src/query/scope.ts`).
export function useCancelTask(
  taskId: string,
): ReturnType<typeof useMutation<void, Error, void>> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, Error, void>({
    mutationFn: () => cancelTask(taskId),
    onSuccess: () => {
      invalidateTaskViews(queryClient, taskId);
    },
    onError: (error) => {
      handleTaskActionError(queryClient, taskId, error, t);
    },
  });
}
